/* eslint-disable camelcase */
export function INIT(state) {
	state.init = true;
}

export function RESET(state) {
	state.type = null;
	state.data = null;
	state.last_import = null;
	state.last_import_count = 0;
	state.status = null;
}

export function UPDATE_DATASOURCE(state, datasource) {
	Object.assign(state, datasource);
}
